const REQUIRED_SURFACED_HEADWEAR_TYPE_BY_LANDING = Object.freeze({
  'printed-caps': 'classic_baseball',
});

export function resolveSurfacedProducts(landing, productMap) {
  const requiredHeadwearType = REQUIRED_SURFACED_HEADWEAR_TYPE_BY_LANDING[landing?.key];

  return (landing?.surfacedSkus || []).map((sku) => {
    const product = productMap[sku];
    if (!product) {
      throw new Error(`Missing surfaced SKU "${sku}" for headwear landing "${landing.key}"`);
    }
    if (requiredHeadwearType && product.headwearType !== requiredHeadwearType) {
      throw new Error(
        `${landing.key} surfaced SKU "${sku}" must be ${requiredHeadwearType}, received "${product.headwearType || 'missing'}"`,
      );
    }
    return product;
  });
}
